export const columns = [
    { key: "measurement", label: "Measurement", minWidth: 170, type: "name" },
    { key: "value", label: "Value", minWidth: 170, type: "number" },
  ];